import { OpeningHourStoryblok } from "@/component-types-sb";

// Entries with only "day" or only "time" filled in render as a plain text line,
// so editors can add notes such as "Mi-Sa Mittagessen für Gruppen auf Anfrage"
// or special opening hours without squeezing them into another entry.
const formatOpeningHour =(entry: OpeningHourStoryblok) =>
  [entry.day?.trim(), entry.time?.trim()].filter(Boolean).join(": ");

export default function OpeningHours({
  entries,
  className,
}: Readonly<{ entries?: OpeningHourStoryblok[]; className?: string }>) {
  return (
    <ul className={className}>
      {entries?.map((entry) => {
        const text = formatOpeningHour(entry);
        return text ? <li key={entry._uid}>{text}</li> : null;
      })}
    </ul>
  );
}
